import React, { useState, useEffect } from 'react'
import Container from '@material-ui/core/Container'
import Grid from '@material-ui/core/Grid'
import withStyles from '@material-ui/core/styles/withStyles'
import CardActionArea from '@material-ui/core/CardActionArea'
import { connect } from "react-redux"
import CardContent from '@material-ui/core/CardContent'
import Input from '@material-ui/core/Input'
import TopBarNav from '../common/TopBarNav'
import { useHistory } from 'react-router-dom'
import { ToastContainer, toast } from 'react-toastify'
import 'react-toastify/dist/ReactToastify.css'
import DataTable from 'react-data-table-component'
import { IndirectStylesInvoice } from './IndirectStyles'
import Button from '@material-ui/core/Button'
import ButtonGroup from '@material-ui/core/ButtonGroup'
import DeleteIcon from "@material-ui/icons/Delete"
import IconButton from '@material-ui/core/IconButton'
import 'react-toastify/dist/ReactToastify.css'
import * as IndirectActions from '../../actions/indirects/IndirectActions'
import { bindActionCreators } from 'redux'
import BreadcrumbsHistory from '../common/BreadcrumbsHistory'
import * as navigationActions from '../../actions/common/NavigationActions'
import { getInvoiceHitoricalTableColumns, getRejectedInvoiceTableColumns } from '../common/Utils'
import { Backdrop, CircularProgress } from '@material-ui/core'

const paginationOptions = { rowsPerPageText: 'Filas por página', rangeSeparatorText: 'de', selectAllRowsItem: true, selectAllRowsItemText: 'Todos' }

const IndirectUploadInvoice = ({ classes, ...props }) => {
    const history = useHistory()
    const [fileXML, setFileXml] = useState()
    const [filePDF, setFilePdf] = useState()
    const { match: { params } } = props
    const [statusGridInvoice, setStatusGridInvoice] = useState(false)
    const [statusGridHistory, setStatusGridHistory] = useState(true)
    const [nameXML, setNameXML] = useState('')
    const [namePDF, setNamePDF] = useState('')
    const [statusNameXmlHidden, setStatusNameXmlHidden] = useState(true)
    const [statusNamePdfHidden, setStatusNamePdfHidden] = useState(true)
    const [textInvoice, setTextInvoice] = useState(classes.TextSelected)
    const [textHistory, setTextHistory] = useState(classes.Text)
    const [disabledButton, setDisabledButton] = useState(false)
    const [hiddenStatus, setHiddenStatus] = useState(true)

    const [buttonInvoice, setButtonbuttonInvoice] = useState(classes.GridBorderSelected)
    const [buttonHistory, setButtonbuttonHistory] = useState(classes.GridBorder)
    const [statusGridRejectedInvoice, setStatusGridRejectedInvoice] = useState(true)
    const [openBackdrop, setOpenBackdrop] = useState(false)

    useEffect(() => {
        handleOpenBackdrop()
        const newRoute = {
            path: '/indirect/UploadInvoice',
            linkLegend: 'Subir factura',
            urlParams: [{ key: 'orderId', value: params.orderId }]
        }
        props.navigationActions.add_route(newRoute)
        props.actions.fetch_Order_Detail(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
        props.actions.fetch_Rejected_Invoice(props.userLanguage, props.userToken, params.orderId, onError, onSuccessFetch)
        return () => {
            props.cleanUserProfile()
        }
    }, []) // eslint-disable-line react-hooks/exhaustive-deps

    useEffect(() => {
        if (props.listRejectedInvoices.length === 0) {
            setDisabledButton(false)
            setStatusGridRejectedInvoice(true)
        } else {
            setDisabledButton(true)
            setStatusGridRejectedInvoice(false)
        }
    }, [props.listRejectedInvoices]) // eslint-disable-line react-hooks/exhaustive-deps

    const handleCloseBackdrop = () => {
        setOpenBackdrop(false);
    }
    const handleOpenBackdrop = () => {
        setOpenBackdrop(true);
    }
    const onSuccessFetch = () => {
        handleCloseBackdrop()
    }

    const onError = (err) => {
        handleCloseBackdrop()
        if (err.response && err.response.status) {
            switch (err.response.status) {
                case 401:
                    props.tokenExpired()
                    history.push('/login')
                    break
                case 403:
                    history.push('/forbidden')
                    break
                case 500:
                    console.log(err.response.data)
                    break
                default:
                    break
            }
        }
    }

    const ChangeOption = (e) => {

        switch (e) {
            case 'Invoice':
                setButtonbuttonInvoice(classes.GridBorderSelected)
                setButtonbuttonHistory(classes.GridBorder)
                setTextInvoice(classes.TextSelected)
                setTextHistory(classes.Text)
                setStatusGridInvoice(false)
                setStatusGridHistory(true)
                props.listRejectedInvoices.length === 0 ? setStatusGridRejectedInvoice(true) : setStatusGridRejectedInvoice(false)
                break;
            case 'History':
                handleOpenBackdrop()
                props.actions.fetch_Invoice_History(props.userLanguage, props.userToken, props.orderDetail.id, onError, onSuccessFetch)
                setButtonbuttonInvoice(classes.GridBorder)
                setButtonbuttonHistory(classes.GridBorderSelected)
                setTextInvoice(classes.Text)
                setTextHistory(classes.TextSelected)
                setStatusGridInvoice(true)
                setStatusGridHistory(false)
                setStatusGridRejectedInvoice(true)
                break;
            default:
                break;
        }
    }

    const onChangeHandlerXML = event => {
        if (checkFileTypeXML(event)) {
            setFileXml(event.target.files[0])
            setStatusNameXmlHidden(false)
            setNameXML(event.target.files[0].name)
        } else {
            setStatusNameXmlHidden(true)
            setNameXML('')
            setFileXml(null)
        }
    }

    const onChangeHandlerPDF = event => {
        if (checkFileTypePDF(event)) {
            setFilePdf(event.target.files[0])
            setStatusNamePdfHidden(false)
            setNamePDF(event.target.files[0].name)
        } else {
            setStatusNamePdfHidden(true)
            setNamePDF('')
            setFilePdf(null)
        }
    }

    const checkFileTypeXML = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['text/xml']

            if (types.every(type => file.type !== type)) {
                toast.error(file.type + " Formato no soportado", { className: classes.toastError })
                event.target.value = null
                return false
            } else {
                return true
            }
        }
    }

    const checkFileTypePDF = event => {
        let file = event.target.files[0]
        if (file != null) {
            let types = ['application/pdf']

            if (types.every(type => file.type !== type)) {
                toast.error(file.type + " Formato no soportado", { className: classes.toastError })
                event.target.value = null
                return false
            } else {
                return true
            }
        }
    }

    const SendFile = () => {
        if (fileXML != null && filePDF != null) {
            handleOpenBackdrop()
            const formData = new FormData();
            formData.append('files', fileXML);
            formData.append('files', filePDF);
            props.actions.Update_Invoice(props.userLanguage, props.userToken, params.orderId, formData, onError, onSuccess)

            setDisabledButton(true)
            setHiddenStatus(false)
        } else {
            toast.info("Debes de seleccionar los archivos XML y PDF para poder guardar.")
        }
    }

    const onSuccess = (response) => {
        handleCloseBackdrop()
        if (response.status) {
            toast.success('Se agregó correctamente la factura', { className: classes.toastSuccess })
            if (response.partial === true) {
                setDisabledButton(false)
                setHiddenStatus(true)
            } else {
                setDisabledButton(true)
                setHiddenStatus(false)
            }
            ClearXML()
            ClearPDF()
        }
        else {
            toast.error('Ocurrió un error al validar la factura', { className: classes.toastError })
            setDisabledButton(false)
            setHiddenStatus(true)
        }
    }

    const ClearXML = () => {
        Array.from(document.querySelectorAll('div.fileXML > input')).forEach(
            input => (input.value = "")
        )

        setStatusNameXmlHidden(true)
        setNameXML('')
        setFileXml(null)
    }

    const ClearPDF = () => {
        Array.from(document.querySelectorAll('div.filePDF > input')).forEach(
            input => (input.value = "")
        )

        setStatusNamePdfHidden(true)
        setNamePDF('')
        setFilePdf(null)
    }

    const DeleteRejectedInvoice = (invocieId) => {
        handleOpenBackdrop()
        props.actions.delete_Rejected_Invoice(props.userLanguage, props.userToken, invocieId, onSuccessDelete, onError)
    }

    const onSuccessDelete = () => {
        handleCloseBackdrop()
        toast.success('Factura eliminada', { className: classes.toastSuccess })
        props.actions.fetch_Rejected_Invoice(props.userLanguage, props.userToken, params.orderId, onError)
    }

    return (
        <div>
            <TopBarNav />
            <br />

            <Container maxWidth="lg" >
                <Backdrop className={classes.backdrop} open={openBackdrop}>
                    <CircularProgress color="inherit" />
                </Backdrop>
                <Grid container>
                    <Grid item xs={4} style={{ marginLeft: '-25px' }}>
                        <BreadcrumbsHistory />
                    </Grid>
                    <Grid item xs={8}>
                        <h5>Detalles de la orden de trabajo Subir factura</h5>
                    </Grid>
                </Grid>
            </Container>

            <Container maxWidth="lg" className={classes.root}>
                <Grid container item xs={12} spacing={3} >
                    <Grid item xs={12} className={classes.dashboardAlign}>
                        <br />
                        <h6>Número de la PO: {props.orderDetail.poNumber}</h6>
                        <h6 hidden={hiddenStatus}>STATUS FACTURA: En revisión de pago</h6>
                        <br />
                    </Grid>
                </Grid>
                <Grid container item xs={12} className={classes.ContainerBorder} >
                    <Grid item xs={3} className={classes.ContainerOptionBorder} >
                        <CardActionArea className={buttonInvoice} onClick={(e) => ChangeOption("Invoice")} style={{ marginBottom: '5px' }}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textInvoice}>Subir Factura</h5>
                            </CardContent>
                        </CardActionArea>

                        <CardActionArea className={buttonHistory} onClick={(e) => ChangeOption("History")}>
                            <CardContent className={classes.dashboardAlign}>
                                <h5 className={textHistory}>Historial de errores</h5>
                            </CardContent>
                        </CardActionArea>

                    </Grid>
                    <Grid item xs={9} >
                        <Container maxWidth="lg" >
                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <br />
                                    <br />
                                    <Grid container item xs={12}>
                                        <Grid item xs={8}>
                                            <div className="form-group files">
                                                <label>Subir XML &nbsp;&nbsp;</label>
                                                <Input type="file" name="file" disabled={disabledButton} className="fileXML" onChange={onChangeHandlerXML} />
                                            </div>
                                        </Grid>
                                        <br />
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <Grid container item xs={12} hidden={statusNameXmlHidden}>
                                        <Grid item xs={7} style={{ textAlign: 'right', paddingTop: '15px', paddingright: '10px' }}>
                                            <label>{nameXML}</label>
                                        </Grid>
                                        <Grid item xs={5} style={{ textAlign: 'left' }}>
                                            <IconButton aria-label="delete" className={classes.ButtonDelete} disabled={disabledButton} onClick={ClearXML}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <br />
                                    <Grid container item xs={12}>
                                        <Grid item xs={8}>
                                            <div className="form-group files">
                                                <label>Subir PDF &nbsp;&nbsp;</label>
                                                <Input type="file" name="file" disabled={disabledButton} className="filePDF" onChange={onChangeHandlerPDF} />
                                            </div>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>
                            <Grid container item xs={12} hidden={statusGridInvoice} >
                                <Grid item xs={12} className={classes.dashboardAlign}>
                                    <Grid container item xs={12} hidden={statusNamePdfHidden}>
                                        <Grid item xs={7} style={{ textAlign: 'right', paddingTop: '15px', paddingright: '10px' }}>
                                            <label>{namePDF}</label>
                                        </Grid>
                                        <Grid item xs={5} style={{ textAlign: 'left' }}>
                                            <IconButton aria-label="delete" className={classes.ButtonDelete} disabled={disabledButton} onClick={ClearPDF}>
                                                <DeleteIcon />
                                            </IconButton>
                                        </Grid>
                                    </Grid>
                                </Grid>
                            </Grid>

                            <Grid item xs={12} hidden={statusGridInvoice} style={{ textAlign: 'center', paddingTop: '10px' }}>
                                <Grid container item xs={12}>
                                    <Grid item xs={9}></Grid>
                                    <Grid item xs={3}>
                                        <ButtonGroup disableElevation variant="contained" size="small" aria-label="small outlined button group">
                                            <Button type="button" className={classes.generalBorder} variant="outlined" disabled={disabledButton} onClick={SendFile}>Guardar</Button>
                                        </ButtonGroup>
                                    </Grid>
                                </Grid>
                            </Grid>

                            {
                                props.listRejectedInvoices && (
                                    <Grid item xs={12} hidden={statusGridRejectedInvoice} style={{ paddingTop: '15px' }}>
                                        <DataTable
                                            columns={getRejectedInvoiceTableColumns('Indirect', { DeleteRejectedInvoice })}
                                            data={props.listRejectedInvoices}
                                            defaultSortField=""
                                            noHeader={true}
                                            dense
                                            highlightOnHover
                                            pointerOnHover
                                        />
                                    </Grid>
                                )
                            }

                            <br />
                            <br />
                            <Grid container item xs={12} hidden={statusGridHistory} >
                                <Grid item xs={12} >
                                    <DataTable
                                        columns={getInvoiceHitoricalTableColumns('Indirect')}
                                        data={props.listHistory}
                                        defaultSortField=""
                                        noHeader={true}
                                        dense
                                        highlightOnHover
                                        pointerOnHover
                                        pagination
                                        paginationComponentOptions={paginationOptions}
                                    />
                                </Grid>
                            </Grid>
                            <br />
                            <br />
                        </Container>
                    </Grid>
                </Grid>
                <br />
            </Container>

            <ToastContainer />
        </div>
    )
}

const mapStateToProps = state => ({
    userProfile: state.UserProfileReducer.list,
    listHistory: state.IndirectReducer.historyList,
    orderDetail: state.IndirectReducer.orderDetail,
    listRejectedInvoices: state.IndirectReducer.listRejectedInvoices,
    isUserAuthenticated: state.LoginReducer.isAuthenticated,
    userToken: state.LoginReducer.token,
    userLanguage: state.LoginReducer.language
})

const mapDispatchToProps = dispatch => {
    return {
        tokenExpired: () => dispatch({ type: 'TOKEN_EXPIRED' }),
        cleanUserProfile: () => dispatch({ type: 'CLEAN_USER_PROFILE' }),
        actions: bindActionCreators(IndirectActions, dispatch),
        navigationActions: bindActionCreators(navigationActions, dispatch)
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(withStyles(IndirectStylesInvoice)(IndirectUploadInvoice))
